import React from "react";
import LoadSpinner from "./LoadSpinner";
import "./LoadSpinner.scss";
import { withDefaults } from "../../utils/withDefaults";

export interface LoadingGlassProps {
  style?: React.CSSProperties;
}

export default function LoadingGlass(incomingProps: LoadingGlassProps) {
  const { style } = withDefaults(incomingProps, loadingGlassDefaultProps);

  return (
    <div className="loading-glass" style={style}>
      <LoadSpinner />
    </div>
  );
}

const loadingGlassDefaultProps = {
  style: {}
};
